<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info"> Quality Management </span>
  </div>

  <div class="container p-5 !pt-0 !pb-0">
    <!-- Quality Management -->
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <div
        class="container-fluid flex justify-center h-auto !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!pb-0 !bg-[#ffffff] w-full !pt-[22px]">
          <h3 class="sub-title !pl-[16px] !mb-[0px] !pt-0 !pb-[22px]">
            Quality Management System (QMS)
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container p-5 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label> Do you have a documented QMS? </label>
                  <mat-radio-group
                    formControlName="using_qms"
                    aria-label="Health and Safety Policy"
                    class="flex gap-4"
                  >
                    <mat-radio-button value="1">Yes</mat-radio-button>
                    <mat-radio-button value="0">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="container p-5 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <mat-label>
                    Provide details of any quality certifications (e.g., ISO
                    9001)
                  </mat-label>
                  <textarea
                    matInput
                  rows="4"
                    formControlName="quality_certifications_detail"
                    placeholder="Provide details of any quality certifications (e.g., ISO 9001)"
                  ></textarea>
                  
                </mat-form-field>
              </div>
              <app-file-manager
              [newFileControlName]="'qualityCertificationsDetailControl'"
              (newFilesUpdatedEvent)="handleNewFiles($event)"
              [oldFiles]="oldQualityCertificationsDetail"
              (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
            ></app-file-manager>
            </div>
            <div class="container p-5 !pt-0 !pb-0 mt-3">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <mat-label>
                    How do you ensure compliance with quality standards on
                    construction projects?
                  </mat-label>
                  <textarea
                    matInput
                    rows="4"
                    formControlName="compliance_process"
                    placeholder="How do you ensure compliance with quality standards on construction projects?"
                  ></textarea>
                </mat-form-field>
                <app-file-manager
                [newFileControlName]="'complianceProcessControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldComplianceProcess"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
              </div>
            </div>

            <h3 class="sub-title !pl-[16px] !mb-[0px] !pt-[12px] !pb-[22px]">
              Defects and Warranty
            </h3>

            <div class="container p-5 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <mat-label>
                    Outline your approach to managing construction defects
                    during and after project completion.
                  </mat-label>
                  <textarea
                    matInput
                    rows="3"
                    formControlName="defects_management"
                    placeholder="Outline your approach to managing construction defects during and after project completion."
                  ></textarea>
                </mat-form-field>
                <app-file-manager
                [newFileControlName]="'defectsManagementControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldDefectsManagement"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
              </div>
            </div>
            <div class="container p-5 !pt-0 !pb-0 !mb-[39px] mt-3">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px] ">
                <mat-form-field
                  class="w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Warranty period </mat-label>
                  <input
                    type="number"
                    matInput
                    formControlName="warranty_period"
                    placeholder=" Warranty period"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
